export enum AgentSessionEventEnum {
  Unsupported = 0,
  StateEvent = 1,
  CallContactEvent = 2,
  Disconnected = 3,
}
